type Props = {
  className?: string;
  size?: number;
};

/**
 * 巫女キャラ立ち絵 (placeholder SVG — Track C の本素材到着で差し替え)。
 * シルエット + 朱袴 + 白衣の最小限。
 */
export function Miko({ className, size = 240 }: Props) {
  return (
    <svg
      viewBox="0 0 200 320"
      width={size}
      height={size * (320 / 200)}
      className={className}
      aria-hidden
    >
      <defs>
        <linearGradient id="miko-hakama" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#9f1d35" />
          <stop offset="100%" stopColor="#6b1024" />
        </linearGradient>
        <linearGradient id="miko-hair" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1a1a1a" />
          <stop offset="100%" stopColor="#0a0608" />
        </linearGradient>
      </defs>
      {/* 袴 (skirt) */}
      <path
        d="M 60 200 Q 50 220 40 300 L 160 300 Q 150 220 140 200 Z"
        fill="url(#miko-hakama)"
      />
      {/* 帯 */}
      <rect x="62" y="194" width="76" height="10" fill="#c9a961" />
      {/* 白衣 (top) */}
      <path
        d="M 70 110 Q 60 140 60 200 L 140 200 Q 140 140 130 110 Z"
        fill="#f5f1e8"
      />
      {/* 袖 */}
      <path d="M 60 130 L 40 180 L 56 186 L 70 145 Z" fill="#f5f1e8" />
      <path d="M 140 130 L 160 180 L 144 186 L 130 145 Z" fill="#f5f1e8" />
      {/* 首 */}
      <rect x="92" y="96" width="16" height="20" fill="#f0d8c0" />
      {/* 顔 */}
      <ellipse cx="100" cy="78" rx="28" ry="32" fill="#f0d8c0" />
      {/* 髪 (long, behind) */}
      <path
        d="M 70 76 Q 68 60 100 48 Q 132 60 130 76 L 134 200 L 66 200 Z"
        fill="url(#miko-hair)"
      />
      {/* 顔のパーツを再描画 (髪の前) */}
      <ellipse cx="100" cy="80" rx="26" ry="30" fill="#f0d8c0" />
      {/* 前髪 */}
      <path
        d="M 74 70 Q 100 50 126 70 Q 116 64 100 64 Q 84 64 74 70 Z"
        fill="url(#miko-hair)"
      />
      {/* 目 (静寂) */}
      <path d="M 86 82 Q 90 84 94 82" stroke="#1a1a1a" strokeWidth="1.5" fill="none" />
      <path d="M 106 82 Q 110 84 114 82" stroke="#1a1a1a" strokeWidth="1.5" fill="none" />
      {/* 口 */}
      <path d="M 96 92 Q 100 94 104 92" stroke="#9f1d35" strokeWidth="1" fill="none" />
    </svg>
  );
}
